import { Col, DatePicker, Form, Input, Row, Select, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Option } from "antd/es/mentions";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import newLogo from "../../assets/new_logo.png";
import Search from "antd/es/transfer/search";
import moment from "moment";
import { insurerListController } from "../Helper/provider";
import AxiosInstance from "../../AxiosInstance";
import {
  countryCodeOptions,
  countryCodeWithoutFlag,
} from "../../utils/countryCodeOptions";
export default function LdmsInvestor() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    watch,
  } = useForm({ mode: "onChange" });
  const [insurer, setInsurer] = useState([]);
  const [businessPartner, setBusinessPartner] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const workingWithValue = watch("insurerId");
  const otherInsurer = insurer.find(
    (item) => (item.name || "").trim().toLowerCase() === "other"
  );
  const isWorkingWithOther =
    !!otherInsurer && workingWithValue === otherInsurer.insurerId;
  useEffect(() => {
    getSpinnerData();
    countryCodeChanged("+91");
  }, []);

  const onSubmit = (value) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    value.approxInvesmentAmount = parseInt(value.approxInvesmentAmount);
    value.leadType = "USER";
    value.source = "INTERNAL";
    console.log(value);
    const url = `/lead/insurer/profile`;
    AxiosInstance()
      .post(url, value, {
        headers: { "x-api-key": "e4VTnkD8CewacUPM4SZ7ga7VulPibp1Z" },
      })
      .then((resp) => {
        let { data } = resp;
        message.success( "Your referral has been shared successfully. Thank you!", 2);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        message.error(
          error?.response?.data?.message || "something went wrong, please try again"
        );
        setIsSubmitting(false);
      });
  };
  const onSubmitError = (formErrors) => {
    console.log("LDMS form validation errors:", formErrors);
    message.error("Please fill all the required fields marked with *");
  };
  const BUSINESS_PARTNER_ALLOWED_IDS = [12, 8, 9, 2];
  const BUSINESS_PARTNER_ALL_TYPES = [
    "ALL",
    "POLICY_MASTER",
    "PARTNER",
    "INVESTOR",
    "PARTNER_INVESTOR",
    "PARTNER_POLICY_MASTER",
    "INVESTOR_POLICY_MASTER",
  ].join(",");
  const AMS_COMTEL = { businessPartnerId: 2, name: "AMS Comtel" };
  const getBusinessPartner = (id) => {
    const url = `/misc/businessPartner/${id}?type=${BUSINESS_PARTNER_ALL_TYPES}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        const filtered = (data || []).filter((item) =>
          BUSINESS_PARTNER_ALLOWED_IDS.includes(item.businessPartnerId)
        );
        const hasAms = filtered.some(
          (item) => item.businessPartnerId === AMS_COMTEL.businessPartnerId
        );
        setBusinessPartner(hasAms ? filtered : [...filtered, AMS_COMTEL]);
      });
  };
  const roleChange = (role) => {
    errors.role = false;
    setValue("role", role);
  };

  const getSpinnerData = async () => {
    const result = await insurerListController(true);
    let id = result.find(
      (insurer) => insurer.name === "Axis Max Life Insurance Co. Ltd."
    ).insurerId;
    getBusinessPartner(id);
    setInsurer(result);
  };
  const insurerChange = (insurerId) => {
    errors.insurerId = false;
    const parsed = parseInt(insurerId, 10);
    setValue("insurerId", Number.isNaN(parsed) ? insurerId : parsed);
  };
  const businessPartnerChange = (businessPartnerId) => {
    errors.businessPartnerId = false;
    setValue("businessPartnerId", businessPartnerId);
  };
  const onChange = (e) => {
    setValue("remarks", e.target.value);
  };
  const countryCodeChanged = (value) => {
    console.log(value);
    setValue("countryCode", value);
  };

  return (
    <div>
      <div className="website-header d-flex justify-content-between">
        <img className="" src={newLogo} height={75} alt="logo-login" />
        <h4 className="m-3">
          <b>
            {" "}
            LEAD &nbsp;CREATION &nbsp;SYSTEM&nbsp; - &nbsp;INVESTOR &nbsp;&
            &nbsp; PARTNER
          </b>
        </h4>
        <div className="d-flex flex-row">
          {/* <img className="" src={newLogo} height={60} alt="logo-login" /> */}
        </div>
      </div>
      <div className="mt-5 " style={{ marginLeft: "19%", marginRight: "19%" }}>
        <form
          className="mt-0 mt-md-5"
          id="leadForm"
          onSubmit={handleSubmit(onSubmit, onSubmitError)}
        >
          <Form
            labelAlign="left"
            labelCol={{
              span: 10,
            }}
            wrapperCol={{
              span: 14,
            }}
            layout="horizontal"
            //   disabled={componentDisabled}
            // style={{
            //   minWidth: 600,
            // }}
          >
            <div className=" ">
              <div className="row gx-5">
                <div className="col-sm-12  col-md-6">
                  <Form.Item
                    // tooltip="This is a required field"

                    label={
                      <>Profile {<span style={{ color: "red" }}>*</span>}</>
                    }
                  >
                    <div>
                      {" "}
                      <Controller
                        name="role"
                        control={control}
                        errors={errors}
                        rules={{ required: true }}
                        render={(props) => (
                          <Select
                            placeholder="Select Profile"
                            onChange={roleChange}
                            className={`${errors.role ? "is-invalid" : ""}`}
                          >
                            <Option key="INVESTOR" value="INVESTOR">
                              INVESTOR
                            </Option>
                            <Option key="PARTNER" value="PARTNER">
                              PARTNER
                            </Option>
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">Role is required</div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={<>Name{<span style={{ color: "red" }}>*</span>}</>}
                    // tooltip="This is a required field"
                    className="mb-5"
                  >
                    <input
                      id="name"
                      // placeholder="Enter Customer Name"
                      className={`form-control ${
                        errors.name ? " is-invalid" : ""
                      }`}
                      {...register("name", {
                        required: {
                          value: true,
                          message: "name is required",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.name?.message}
                    </div>
                  </Form.Item>

                  <Form.Item
                    label={
                      <>
                        Contact Number{<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <Row gutter={10}>
                      <Col span={9}>
                        <Select
                          className="countryCode "
                          aria-label=".form-select-sm Default select example"
                          onChange={countryCodeChanged}
                          size="large"
                          style={{
                            width: "100%",
                            height: "48px",
                          }}
                          defaultValue={"+91"}
                        >
                          {countryCodeWithoutFlag()}
                        </Select>
                      </Col>
                      <Col span={15}>
                        <input
                          id="phoneNumber"
                          maxLength={10}
                          className={`form-control ${
                            errors.phoneNumber ? " is-invalid" : ""
                          }`}
                          {...register("phoneNumber", {
                            required: {
                              value: true,
                              message: "phone number is required",
                            },
                            pattern: {
                              value: /^[6789]\d{9}$/,
                              message: "Enter a valid number",
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors?.phoneNumber?.message}
                        </div>
                      </Col>
                    </Row>
                  </Form.Item>

                  <Form.Item
                    label={
                      <>Email Id{<span style={{ color: "red" }}>*</span>}</>
                    }
                    // tooltip="This is a required field"
                  >
                    <input
                      id="email"
                      // placeholder="Enter Contact Number"

                      className={`form-control ${
                        errors.email ? " is-invalid" : ""
                      }`}
                      {...register("email", {
                        required: {
                          value: true,
                          message: "email is required",
                        },
                        pattern: {
                          value:
                            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,

                          message: "enter valid email",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.email?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    label="City"

                    // tooltip="This is a required field"
                  >
                    <input
                      id="city"
                      // placeholder="Enter Contact Number"

                      className={`form-control ${
                        errors.city ? " is-invalid" : ""
                      }`}
                      {...register("city")}
                    />
                    <div className="invalid-feedback">
                      {errors?.city?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={<>Approx Inv. Amt</>}
                    // tooltip="This is a required field"
                  >
                    <input
                      id="approxInvesmentAmount"
                      // placeholder="Enter Contact Number"

                      className={`form-control ${
                        errors.approxInvesmentAmount ? " is-invalid" : ""
                      }`}
                      {...register("approxInvesmentAmount", {
                        pattern: {
                          value: /^\d+$/,

                          message: "enter valid number",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.approxInvesmentAmount?.message}
                    </div>
                  </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6">
                  <Form.Item
                    // tooltip="This is a required field"
                    className="mb-5"
                    label={
                      <>
                        Business Partner
                        {isWorkingWithOther && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </>
                    }
                  >
                    <div>
                      <Controller
                        name="businessPartnerId"
                        control={control}
                        errors={errors}
                        rules={{
                          validate: (value) =>
                            !isWorkingWithOther ||
                            !!value ||
                            "business partner is required",
                        }}
                        render={(props) => (
                          <Select
                            className={`${
                              errors.businessPartnerId ? "is-invalid" : ""
                            }`}
                            value={getValues("businessPartnerId")}
                            placeholder="Select Partner"
                            onChange={businessPartnerChange}
                            size="large"
                            style={{ width: "100%" }}
                          >
                            {businessPartner.map((item) => (
                              <Option
                                key={item.businessPartnerId}
                                value={item.businessPartnerId}
                              >
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">
                        {errors?.businessPartnerId?.message}
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    // tooltip="This is a required field"
                    className="mb-5"
                    label={
                      <>
                        Working With{<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <div>
                      <Controller
                        name="insurerId"
                        control={control}
                        errors={errors}
                        rules={{
                          required: {
                            value: true,
                            message: "working with is required",
                          },
                        }}
                        render={(props) => (
                          <Select
                            className={`${
                              errors.insurerId ? "is-invalid" : ""
                            }`}
                            value={getValues("insurerId")}
                            placeholder="Select Insurer"
                            onChange={insurerChange}
                            size="large"
                            style={{ width: "100%" }}
                          >
                            {[...insurer]
                              .sort((a, b) => {
                                const aIsOther =
                                  (a.name || "").trim().toLowerCase() ===
                                  "other";
                                const bIsOther =
                                  (b.name || "").trim().toLowerCase() ===
                                  "other";
                                return aIsOther === bIsOther
                                  ? 0
                                  : aIsOther
                                  ? -1
                                  : 1;
                              })
                              .map((item) => (
                                <Option
                                  key={item.insurerId}
                                  value={item.insurerId}
                                >
                                  {item.name}
                                </Option>
                              ))}
                          </Select>
                        )}
                      />
                      <div className="invalid-feedback">
                        {errors?.insurerId?.message}
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={
                      <>
                        Referred By{<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <input
                      id="partnerName"
                      // placeholder="Enter Contact Number"

                      className={`form-control ${
                        errors.partnerName ? " is-invalid" : ""
                      }`}
                      {...register("partnerName", {
                        required: {
                          value: true,
                          message: "referred by is required",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.partnerName?.message}
                    </div>
                  </Form.Item>
                  <Form.Item
                    label={
                      <>
                        Employee Code{<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <input
                      id="referralCode"
                      // placeholder="Enter Contact Number"

                      className={`form-control ${
                        errors.referralCode ? " is-invalid" : ""
                      }`}
                      {...register("referralCode", {
                        required: {
                          value: true,
                          message: "employee code is required",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.referralCode?.message}
                    </div>
                  </Form.Item>
                  <Form.Item label="Office Code">
                    <input
                      id="officeCode"
                      // placeholder="Enter Agent Code"
                      className={`form-control ${
                        errors.officeCode ? " is-invalid" : ""
                      }`}
                      {...register("officeCode", {
                        // required: true,
                      })}
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <>
                        Employee Number
                        {<span style={{ color: "red" }}>*</span>}
                      </>
                    }
                  >
                    <input
                      id="employeeContactNo"
                      // placeholder="Enter Agent Code"
                      className={`form-control ${
                        errors.employeeContactNo ? " is-invalid" : ""
                      }`}
                      {...register("employeeContactNo", {
                        required: {
                          value: true,
                          message: "employee number is required",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.employeeContactNo?.message}
                    </div>
                  </Form.Item>
                  <Form.Item label="Remarks">
                    <TextArea rows={4} onChange={onChange} placeholder="" />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* <Form.Item className="d-flex justify-content-center"> */}
            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="normal-button  py-1"
                form="leadForm"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
            {/* </Form.Item> */}
          </Form>
        </form>
      </div>
      {/* <div style={{ position: "fixed", right: "10px", bottom: "10px" }}>
    <img alt="Call Support" style={{ height: "30px" }} src={amsComtel} />
  </div> */}
    </div>
  );
}
